import { createTheme, Theme, ThemeProvider } from "@mui/material"
import { ReactNode } from "react"

// The app's caption and subtitle sizes (0.55rem ≈ 9px) are too small to read on screens that are
// mostly short text — notifications and automations. These get a readable scale; the rest of the
// app keeps its own.
const readable = (outer: Theme) =>
  createTheme(outer, {
    typography: {
      caption: { fontSize: "0.75rem", lineHeight: 1.45 },
      subtitle1: { fontSize: "0.8125rem", lineHeight: 1.4 },
      subtitle2: { fontSize: "0.8125rem", fontWeight: 600, lineHeight: 1.4 }
    }
  })

export function ReadableText({ children }: { children: ReactNode }) {
  return <ThemeProvider theme={readable}>{children}</ThemeProvider>
}
